export function LogoMark({ size = 36 }) {
    return (
        <svg width={size} height={size} viewBox="0 0 64 64" fill="none" aria-hidden="true">
            <defs>
                <linearGradient id="maxth-g" x1="0" y1="0" x2="64" y2="64">
                    <stop offset="0" stopColor="#00f0ff" />
                    <stop offset="1" stopColor="#3b82f6" />
                </linearGradient>
            </defs>
            <rect width="64" height="64" rx="14" fill="#0d1322" />
            <rect x="1.5" y="1.5" width="61" height="61" rx="12.5" stroke="#1e293b" strokeWidth="1.5" />
            <path
                d="M15 45V19l9.5 13.5L32 20.5 39.5 32.5 49 19v26"
                stroke="url(#maxth-g)"
                strokeWidth="4.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <circle cx="32" cy="47" r="2.4" fill="#00f0ff" />
        </svg>
    );
}

export function Logo() {
    return (
        <span className="flex items-center gap-2.5">
            <LogoMark size={38} />
            <span className="leading-none">
                <span className="block font-display text-lg font-bold tracking-tight text-white">
                    MAXTH
                </span>
                <span className="mt-1 block font-mono text-[9px] font-medium tracking-[0.34em] text-neon">
                    SOLUTIONS
                </span>
            </span>
        </span>
    );
}
